var map = {
	"./1.png": 2386,
	"./POIgeneric.jpg": 2387,
	"./cmentarz.jpg": 2388,
	"./hotel.jpg": 2389,
	"./kosciol.jpg": 2390,
	"./kultura.jpg": 2391,
	"./map-icon.png": 2392,
	"./przyroda.jpg": 2393,
	"./rekreacja.jpg": 2394,
	"./schronisko.jpg": 2395,
	"./swieczki.jpg": 2381,
	"./szkola.jpg": 2396,
	"./transport.jpg": 2397,
	"./x.png": 2379,
	"./zabytek.jpg": 2398
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2385;



//////////////////
// WEBPACK FOOTER
// ./components/Modals/SideDescription/img ^\.\/.*$
// module id = 2385
// module chunks = 0